module.exports = __webpack_public_path__ + "static/media/andrea_carreiro.5474f992.jpg";